import React, { useState } from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'
import { AddressAndFamilyContactForm } from './components/AddressAndFamilyContactForm/AddressAndFamilyContactForm'
import { ConfirmAddressAndFamilyContactData } from './components/ConfirmAddressAndFamilyContactData/ConfirmAddressAndFamilyContactData'
import { useAddressAndFamilyContactForm } from './useAddressAndFamilyContactForm'

import { ReactComponent as DocumentFormSVG } from 'static/svg/document-form.svg'

import { useUpdatePersonGeneral } from 'hooks'

import * as S from './styles'

enum StepEnum {
  CONFIRM = 'CONFIRM',
  FORM = 'FORM'
}

function handleModalTitleByStep(step: StepEnum) {
  const title: Record<StepEnum, string> = {
    CONFIRM: 'Confirme se está tudo certo:',
    FORM: 'Para prosseguir no agendamento da sua consulta de psiquiatria, é preciso concluir alguns dados cadastrais.'
  }

  return (
    <S.TitleWrapper>
      {step === StepEnum.FORM && (
        <DocumentFormSVG />
      )}
      <Typography weight='bold' center variant='content1'>
        {title[step]}
      </Typography>
    </S.TitleWrapper>
  )
}

type ModalProps = {
  onSuccess: () => void
}

export const AddressAndFamilyContactModal = ({ onSuccess }: ModalProps): JSX.Element => {
  const { isUpdateSubmitting, onUpdatePersonGeneralData } = useUpdatePersonGeneral({
    successCallback: () => onSuccess()
  })
  const formMethods = useAddressAndFamilyContactForm()

  const [currentStep, setCurrentStep] = useState(StepEnum.FORM)

  const addressValues = formMethods.getValues('address')
  const familyContactValues = formMethods.getValues('familyContact')
  
  return (
    <ModalGeneric
      modalTitle={handleModalTitleByStep(currentStep)}
      hasCloseButton
      hasTopBarActive={false}
    >
      {currentStep === StepEnum.FORM && (
        <AddressAndFamilyContactForm
          handleFormFulfilled={() => setCurrentStep(StepEnum.CONFIRM)} 
          {...formMethods} 
        />
      )}

      {currentStep === StepEnum.CONFIRM && (
        <ConfirmAddressAndFamilyContactData
          handleEditInfo={() => setCurrentStep(StepEnum.FORM)} 
          handleCompleteForm={() => 
            onUpdatePersonGeneralData({ 
              address: addressValues, 
              familyContact: familyContactValues
            })}
          formValues={{
            address: addressValues,
            familyContact: familyContactValues
          }}
          isLoading={isUpdateSubmitting}
        />
      )}
    </ModalGeneric>
  )
}